import React, {useEffect, useState} from 'react'
import BottomToTop from '../../../../components/transitions/bottom-to-top'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../components/icon/iconfont'
import DetailsSwiper from './swiper-videos/details-swiper-videos'

const FixedWindow = props => {
    useStyles(classes)
    const { show, onClose, videos, videoIndex, changeVideoIndex } = props

    return <BottomToTop unmountOnExit in={show} className={classes.FixedVideoPage}>
        <div>
           <div className={classes.Hd}>
                <Iconfont onClick={onClose} className={classes.Close}>&#xe6af;</Iconfont>
                <span className={classes.Title}>{videoIndex+1}/{videos?.length}</span>
           </div>
           <DetailsSwiper position={videoIndex} {...props} positionChange={changeVideoIndex}/>
        </div>
    </BottomToTop>
}

export default props => {
    if (typeof window === 'undefined')
        return null

    return ReactDOM.createPortal(
        <FixedWindow {...props} />,
        document.getElementById('root')
    )
}